import React from 'react';
import { Mail, Instagram } from 'lucide-react';

const Collect = ({ contact }) => {
  return (
    <section className="bg-off-black py-20 sm:py-24 md:py-32 border-t border-deep-charcoal">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 text-center">
        <Mail size={32} strokeWidth={1} className="mx-auto mb-6 sm:mb-8 text-muted-warm-grey" />

        <h2 className="text-3xl sm:text-4xl md:text-5xl font-serif text-soft-ivory mb-4 sm:mb-6 tracking-tight">
          Collect
        </h2>

        <p className="text-base sm:text-lg text-muted-warm-grey mb-10 sm:mb-12 tracking-wide px-2">
          {contact.inquiries}
        </p>

        <div className="space-y-6">
          <a
            href={`mailto:${contact.email}`}
            className="inline-block text-soft-ivory border border-soft-ivory/30 px-8 sm:px-12 py-3 sm:py-4 text-xs sm:text-sm tracking-widest uppercase hover:bg-soft-ivory/10 transition-all duration-500"
          >
            Inquire
          </a>

          <p className="text-xs sm:text-sm text-muted-warm-grey tracking-wide">
            Available works • Commissions • Exhibitions
          </p>

          {/* Social Media */}
          <div className="pt-6 sm:pt-8 border-t border-zinc-800 mt-10 sm:mt-12">
            <p className="text-xs uppercase tracking-widest text-muted-warm-grey mb-4 sm:mb-6">
              Follow
            </p>
            <div className="flex items-center justify-center gap-6">
              <a
                href="https://www.instagram.com/leighwitherell"
                target="_blank"
                rel="noopener noreferrer"
                className="text-soft-ivory/60 hover:text-flesh-tone transition-colors duration-400"
                aria-label="Instagram"
              >
                <Instagram size={24} strokeWidth={1.5} />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Collect;
